import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import styled from 'styled-components';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import { NameCard, DropdownToggle, Icon } from 'modules/theme';
import { UserHelper, BalanceDetails } from '../styles';
import { MdLogout, MdOutlineAccountBalanceWallet, MdOutlineAccountCircle, MdOutlineContactSupport } from 'react-icons/md';
import { IoLogoUsd } from "react-icons/io";
import { HiOutlineCurrencyEuro } from "react-icons/hi";
import { FaRupeeSign } from 'react-icons/fa';
import APIManager from 'modules/common/apiManager';
import { Button } from "../../common/components";
import globalAction from '../../../store/action/global.action';

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    float: none;
    margin: 0 10px;
  }
`;

const NameCardWrapper = styled.div`
  padding: 10px 20px;
`;

const NavItem = styled.div`
  padding-left: 20px;
  display: table-cell;
  vertical-align: middle;
  
  .dropdown-menu {
    min-width: 225px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .dropdown-menu>li>a {
    display: flex;
    align-items: center;
    line-height: 24px;
    color: #36454F;
    
    svg {
      margin-right: 5px;
    }
  }

`;


export class QuickNavigation extends Component {
  
  
  constructor(props) {
    super(props);

    this.userInfo = localStorage.getItem('user')  && JSON.parse(localStorage.getItem('user')) || '';
    this.agentRole = parseInt(this.userInfo.role) || null;

    this.mAPI = new APIManager();

    this.state = {
      availableBalance: 0
    }

    this.getBalance = this.getBalance.bind(this);
    
  }

  componentDidMount() {
      this.getBalance();
    }

  getBalance() {
    this.mAPI.sendPostAPI(
      `${process.env.REACT_APP_API_COMMON_URL}balance`,
      {},
      data => {
        // this.setState({ availableBalance: data.balance })
        this.props.setUserBalance(data.balance);
      },
      error => {
        console.log(error);
      },
      "direct",
    )
  }

  handleClick = () => {  
    if(this.userInfo && this.userInfo["trial_account"] == 1) {
      window.location.href = '/upgrade-account';
    } else {
      window.location.href = '/add-fund';
    }
  }


  render() {
    const hostname = process.env.REACT_APP_HOSTNAME;
    let { logout, currentUser } = this.props;
    const { __ } = this.context;
    console.log(`currentUser`, currentUser);
    currentUser = currentUser || {};

    let icon;
    let rupee = this.userInfo.currency_type || "";

      if(rupee==0){
        icon= <FaRupeeSign />
      } else if (rupee==1){
        icon= < IoLogoUsd />
      } else if (rupee==2)  {
        icon= <HiOutlineCurrencyEuro/>
      }

    return (
      <nav>
        <NavItem>
          <BalanceDetails>
          {/* <span>{this.userInfo["trial_account"]== 0 ? "Available Credits" : "Trial"}</span><br/> */}
          <div style={{ transform: "translateY(-3px)",paddingRight: "20px" }}>
                    <span>
                      {this.userInfo["trial_account"] == 2
                        ? "Available Credits"
                        : "Trial"}
                    </span>
                    <br />
                    <span>
                      {icon} {this.props.userBalance}
                      {/* <Link to="/add-fund"><BsFillPlusSquareFill size={20} /></Link> */}
                    </span>
                  </div>
                  <div>
                    {/* {this.userInfo["trial_account"] != 2 && (
                      <Link
                        to={`/upgrade-account`}
                        style={{
                          fontSize: "14px",
                          verticalAlign: "middle",
                          transform: "translateY(-8px)",
                        }}
                      >
                        {/* <button type="button" class="btn btn-primary" style={{borderRadius:"20px"}}>Upgrade</button> 
                        <Button
                          btnStyle="default"
                          size="small"
                          style={{
                            borderRadius: "10px",
                            textTransform: "capitalize",
                            transform: "translateY(5px)",
                          }}
                        >
                          UPGRADE
                        </Button>
                        <span />
                      </Link>
                    )} */}
                    <span>
                    
                      <Button
                        btnStyle="default"
                        size="small"
                        onClick={this.handleClick}
                        style={{
                          transform: "translateY(5px)",
                          marginLeft:"7px"
                        }}                      
                      >
                        Add Fund
                      </Button>
                      
                    </span>
                  </div>
                  </BalanceDetails>
        </NavItem>

        <NavItem>
          <Dropdown id="dropdown-user" pullRight>
            
                
            <DropdownToggle bsRole="toggle">
              <UserHelper>
                
                <UserInfo>
                {currentUser && currentUser.voiceDetails ? currentUser.voiceDetails.name : currentUser.name}
                  <NameCard.Avatar user={currentUser} size={30} />
                  <Icon icon="downarrow" size={10} />
                </UserInfo>
              </UserHelper>
            </DropdownToggle>
            <Dropdown.Menu>
              <NameCardWrapper>
                <NameCard user={currentUser} />
              </NameCardWrapper>
              
              <MenuItem divider />

              {/* <li>
                <Link to={`/components/team/details/${currentUser._id}`}>
                  {__('View Profile')}
                </Link>
              </li> */}

            <li>
              <a href={`${hostname}/profile`}>
                <MdOutlineAccountCircle size={25} />
                {__('View Profile')}
              </a>
            </li>
              <MenuItem divider />
              <li>
              <a href={`${hostname}/invoice`}>
                  <MdOutlineAccountBalanceWallet size={25} /> 
                {__('Billing')}</a>
              </li>
            <MenuItem divider />
            {/* <li>
              <a href={`${hostname}/account-setting`}>
                <MdOutlineManageAccounts size={28} />
                {__('Manage Account')}</a>
            </li>
            <MenuItem divider /> */}

            <li>
              <a href={`${hostname}/contact-support`}>
                <MdOutlineContactSupport size={28} />
                {__('Support')}</a>
            </li>


            {/* <li>
              <Link to={`/tenant`}>{__('Add Customers')}</Link>
            </li> */}

            {/* <ModalTrigger
              title="Change Password"
              trigger={
                <li>
                  <a>{__('Change Password')}</a>
                </li>
              }
            >
              <ChangePassword />
            </ModalTrigger> */}
            <MenuItem divider />
            <MenuItem onClick={logout}>
              <MdLogout size={25}/> {__('Sign out')}
            </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </NavItem>
      </nav>
    );
  }
}
QuickNavigation.propTypes = {
  logout: PropTypes.func
};

QuickNavigation.contextTypes = {
  currentUser: PropTypes.object,
  __: PropTypes.func
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  userBalance: globalStateSelector.getUserBalance(state),
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  },
  setUserBalance: (balance) => {
    dispatch(globalAction.setUserBalance({ data: balance }));
  }
});
export default connect(stateToProps, dispatchToProps)(QuickNavigation);



// WEBPACK FOOTER //
// ./src/modules/layout/components/QuickNavigation.js